import {
    CONFIRMED_CREATE_REVIEW_ACTION,
    CONFIRMED_DELETE_REVIEW_ACTION,
    CONFIRMED_EDIT_REVIEW_ACTION,
    CONFIRMED_GET_REVIEWS,
    CREATE_REVIEW_ACTION,    
    CREATE_REVIEW_ERROR_ACTION,
    CLEAR_REVIEW_ERROR,
    LOADING_REVIEWS,
    CONFIRMED_UPDATE_REVIEW_STATUS_ACTION 
} from '../actions/ReviewTypes';

const initialState = {
    reviews: [],
    loading: false,
    createReviewError: {}
};

export default function ReviewReducer(state = initialState, actions) {
    if (actions.type === CREATE_REVIEW_ACTION) { 
        return {
            ...state,
            reviews: [...state.reviews],
        };
    }

    if (actions.type === CONFIRMED_DELETE_REVIEW_ACTION) {
        const reviews = state.reviews.filter(review => review.id !== actions.payload);
        return {
            ...state,
            reviews,
        };
    }

    if (actions.type === CONFIRMED_EDIT_REVIEW_ACTION) {
        const reviews = state.reviews.map(review => 
            review.id === actions.payload.id ? actions.payload : review
        );
        return {
            ...state,
            reviews,
        };
    }

    if (actions.type === CONFIRMED_UPDATE_REVIEW_STATUS_ACTION) {
       
        const reviews = state.reviews.map(review => 
            review.id === actions.payload.reviewId ? { ...review, status: actions.payload.status  } : review
        );
        return {
            ...state,
            reviews,
        };
    }

    if (actions.type === CONFIRMED_CREATE_REVIEW_ACTION) {
        return {
            ...state,
            reviews: [...state.reviews, actions.payload],
        };
    }

    if (actions.type === CONFIRMED_GET_REVIEWS) {
        return {
            ...state,
            reviews: actions.payload,
        };
    }

    if (actions.type === LOADING_REVIEWS) {
        return {
            ...state,
            loading: actions.payload,
        };
    }

    if (actions.type === CREATE_REVIEW_ERROR_ACTION) {
        return {
            ...state,
            createReviewError: actions.payload,
        };
    }

    if (actions.type === CLEAR_REVIEW_ERROR) {
        return {
            ...state,
            createReviewError: {},
        };
    }
  
    return state;
}
